/**
 * Demo mode — lets you preview the inbox and item views without a GitHub token.
 *
 * It bundles a few real item files from the repo (via Vite's import.meta.glob)
 * and parses them with the same parser the live app uses. Writes are disabled
 * in demo mode (answers are held in memory only).
 */

import { parseItem, type Item } from "./item";

// Raw markdown files, keyed by their repo path. The whole item space is bundled
// (the items are small) so demo mode is a real snapshot and the glob cannot rot
// when items are renamed. Non-items are filtered out below.
const rawFiles = import.meta.glob(
  ["../../../../agentic/*/open/**/*.md", "../../../../agentic/*/decided/**/*.md"],
  { query: "?raw", import: "default", eager: true },
);

export function loadDemoItems(): Item[] {
  const items: Item[] = [];
  for (const [path, raw] of Object.entries(rawFiles)) {
    // Normalise the absolute-ish path to a repo-relative path.
    const idx = path.indexOf("agentic/");
    const rel = idx >= 0 ? path.slice(idx) : path;
    const item = parseItem(rel, raw as string);
    // `agentic/dev/**` (tooling docs) and long-form reference docs are not items.
    if (item.isItem && !rel.startsWith("agentic/dev/")) items.push(item);
  }
  return items.sort((a, b) => a.filename.localeCompare(b.filename));
}